import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import Link from 'components/core/Link';
import Tooltip from 'components/core/Tooltip';
// Models
import mSimcard from 'models/simcard';
// Custom
import { simcardDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'simcards/navigation';
import AppIcon from 'components/icons/AppIcon';

const SimcardTooltipContent = ({ simcard, statusLabelId }) => (
  <div>
    <div className="row">
      <div className="col-4 text-right pr-2">
        <em>
          <LocalizedMessage id="field.iccid" />
        </em>
      </div>
      <div className="col-8 text-left pl-2">{simcard.iccid}</div>
      <div className="col-4 text-right pr-2">
        <em>
          <LocalizedMessage id="field.number" />
        </em>
      </div>
      <div className="col-8 text-left pl-2">{simcard.number}</div>
      <div className="col-4 text-right pr-2">
        <em>
          <LocalizedMessage id="field.status" />
        </em>
      </div>
      <div className="col-8 text-left pl-2">
        <LocalizedMessage id={statusLabelId} />
      </div>
      <div className="col-4 text-right pr-2">
        <em>
          <LocalizedMessage id="field.group" />
        </em>
      </div>
      <div className="col-8 text-left pl-2">{simcard.group.name}</div>
    </div>

    <div className="pt-2">
      <div className="box-divider-light m-0" />
      <div className="row m-0 pt-2">
        <div className="w-100 text-center">
          <LocalizedMessage id="tooltip.clickToAccess" values={{ resource: 'simcard' }} />
        </div>
      </div>
    </div>
  </div>
);

SimcardTooltipContent.propTypes = {
  simcard: simcardDataShape.isRequired,
  statusLabelId: PropTypes.string.isRequired,
};

const SimcardLink = ({ simcard }) => {
  // Simcard status
  const { labelId, icon, color } = mSimcard.status(simcard);

  return (
    <div className="d-flex align-items-center">
      <AppIcon color={color} id={icon} className="mr-2" />
      <Tooltip
        content={<SimcardTooltipContent simcard={simcard} statusLabelId={labelId} />}
        inheritStyle={false}
        className="text-truncate"
      >
        <Link path={showPath(simcard.id)}>{simcard.iccid}</Link>
      </Tooltip>
    </div>
  );
};

SimcardLink.propTypes = {
  simcard: simcardDataShape.isRequired,
};

module.exports = SimcardLink;



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/main/SimcardLink.js